import { NgModule } from '@angular/core';
import { USER_COMPONENTS, USER_SERVICES } from './index';
import { SharedModule } from '../shared/shared.module';
import { LayoutModule } from '../layout/layout.module';
import { DynamicFormModule } from '@ispm/dynamic-form/dynamic-form.module';

@NgModule({
  imports: [
    LayoutModule,
    DynamicFormModule,
    SharedModule
  ],
  declarations: [...USER_COMPONENTS],
  exports: [...USER_COMPONENTS],
  providers: [...USER_SERVICES

  ]
})

export class UserModule {
}
